var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirconditioning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,24.5c0-0.78-0.64-1.41-1.41-1.41c-0.78,0-1.43,0.63-1.43,1.41c0,0.77,0.65,1.41,1.43,1.41 C18.06,25.91,18.7,25.27,18.7,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.92,24.5c0-0.16,0.02-0.31,0.05-0.47c-0.11,0-0.23,0.02-0.33,0.06l-3.3,1.04 c-0.73,0.24-1.21,0.94-1.18,1.71l0.14,3.2c0.04,0.94,0.85,1.79,1.78,1.63c1.23-0.2,3.36-3.12,4.28-5.01 C15.52,26.3,14.92,25.47,14.92,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.64,24.51c-0.01,1.23-0.94,2.22-2.15,2.33c0.09,0.17,0.21,0.33,0.36,0.46l2.55,2.34 c0.57,0.51,1.41,0.59,2.06,0.18l2.71-1.73c0.79-0.5,1.12-1.62,0.52-2.36C24.94,24.82,21.76,24.43,19.64,24.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.29,22.14c0.54,0,1.05,0.2,1.46,0.51c0.04-0.11,0.08-0.22,0.1-0.34l0.76-3.37 c0.15-0.75-0.21-1.52-0.88-1.87l-2.85-1.49c-0.84-0.43-1.98-0.16-2.31,0.73c-0.45,1.19,1.08,4.6,2.27,6.32 C16.24,22.33,16.76,22.14,17.29,22.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.68,8.92H3.32v31.54h45.35V8.92z M17,35.24c-6.08,0-10.98-4.9-10.98-10.97c0-6.08,4.9-10.98,10.98-10.98 c6.07,0,10.97,4.9,10.97,10.98C27.97,30.34,23.07,35.24,17,35.24z M44.17,35.24h-8.73v-8.93h8.73V35.24z M46.51,20.36H33.09 c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h13.41c0.28,0,0.5,0.22,0.5,0.5S46.78,20.36,46.51,20.36z M46.51,17.78H33.09 c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h13.41c0.28,0,0.5,0.22,0.5,0.5S46.78,17.78,46.51,17.78z M46.51,15.19H33.09 c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h13.41c0.28,0,0.5,0.22,0.5,0.5S46.78,15.19,46.51,15.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.32,8.42v32.54c0,0.28,0.22,0.5,0.5,0.5h4.64v2.62h7.32v-2.62h22.16v2.62h7.32v-2.62h4.9 c0.28,0,0.5-0.22,0.5-0.5V8.42c0-0.28-0.22-0.5-0.5-0.5H2.82C2.55,7.92,2.32,8.14,2.32,8.42z M3.32,8.92h45.35v31.54H3.32V8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,13.29c-6.08,0-10.98,4.9-10.98,10.98c0,6.07,4.9,10.97,10.98,10.97c6.07,0,10.97-4.9,10.97-10.97 C27.97,18.19,23.07,13.29,17,13.29z M13.57,16.31c0.33-0.89,1.47-1.16,2.31-0.73l2.85,1.49c0.67,0.35,1.03,1.12,0.88,1.87 l-0.76,3.37c-0.02,0.12-0.06,0.23-0.1,0.34c-0.41-0.31-0.92-0.51-1.46-0.51c-0.53,0-1.05,0.19-1.45,0.49 C14.65,20.91,13.12,17.5,13.57,16.31z M12.08,31.67c-0.93,0.16-1.74-0.69-1.78-1.63l-0.14-3.2c-0.03-0.77,0.45-1.47,1.18-1.71 l3.3-1.04c0.1-0.04,0.22-0.06,0.33-0.06c-0.03,0.16-0.05,0.31-0.05,0.47c0,0.97,0.6,1.8,1.44,2.16 C15.44,28.55,13.31,31.47,12.08,31.67z M15.86,24.5c0-0.78,0.65-1.41,1.43-1.41c0.77,0,1.41,0.63,1.41,1.41 c0,0.77-0.64,1.41-1.41,1.41C16.51,25.91,15.86,25.27,15.86,24.5z M25.17,28.09l-2.71,1.73c-0.65,0.41-1.49,0.33-2.06-0.18 l-2.55-2.34c-0.15-0.13-0.27-0.29-0.36-0.46c1.21-0.11,2.14-1.1,2.15-2.33c2.12-0.08,5.3,0.31,6.05,1.22 C26.29,26.47,25.96,27.59,25.17,28.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.51,14.19H33.09c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h13.41c0.28,0,0.5-0.22,0.5-0.5 S46.78,14.19,46.51,14.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.51,16.78H33.09c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h13.41c0.28,0,0.5-0.22,0.5-0.5 S46.78,16.78,46.51,16.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.51,19.36H33.09c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h13.41c0.28,0,0.5-0.22,0.5-0.5 S46.78,19.36,46.51,19.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.43,
    y: 26.31,
    className: "st1",
    width: 8.73,
    height: 8.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirconditioning);
export default __webpack_public_path__ + "static/media/airconditioning.3ed63d99c535356be544bee8d6984258.svg";
export { ForwardRef as ReactComponent };